import React, { forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

// Site key comes from the environment so the widget can be configured per
// deployment. When it isn't set (local dev, or before keys are provisioned)
// nothing is rendered and forms keep working — the backend skips verification
// in that case too.
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

export const isRecaptchaEnabled = () => Boolean(RECAPTCHA_SITE_KEY);

// Thin wrapper around the reCAPTCHA v2 checkbox.
//
// Props:
//   onChange(token) – receives the token, or null when it expires/is reset
//   className       – wrapper classes
//
// Forwarded ref exposes the underlying widget so callers can `.reset()` it
// after a failed submit (a token is single-use).
// `center` centres the widget in its container, which suits the centred
// auth forms. Pass center={false} on a left-aligned form so it lines up with
// the fields above it instead of floating in the middle.
const Recaptcha = forwardRef(({ onChange, className = "", center = true }, ref) => {
  if (!RECAPTCHA_SITE_KEY) return null;

  return (
    <div className={`flex my-3 ${center ? "justify-center" : ""} ${className}`}>
      <ReCAPTCHA
        ref={ref}
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={onChange}
        onExpired={() => onChange && onChange(null)}
        onErrored={() => onChange && onChange(null)}
      />
    </div>
  );
});

Recaptcha.displayName = "Recaptcha";

export default Recaptcha;
